import axios from "axios";
import { convertObjectToUrlParams } from "../helpers/convertObjToUrlParams";

export const getCatchReportPeriods = async (params: any = {}) => {
  try {
    const response = await axios.get(
      `${
        process.env.REACT_APP_API
      }/CatchReport/periods${convertObjectToUrlParams(params)}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
